/* eslint-disable */
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import HotelCategoriesRepository from '@/js/common/Domain/Repository/HotelCategories';
import DataLayerAnalytics from "@/js/common/Domain/Service/DataLayerAnalytics";

let HotelCategoryView = Backbone.View.extend({
	label: 'Класс отеля',
	hotelStarsOld: null,
	countryData: null,
	departureCityData: null,
	scrollToElement: function (e) {
		var currenPosition = $(document).scrollTop(),
			$filtersBlock = $('.sideBlock.filters'),
			windowHeight = $(window).height(),
			headerHeight = $('.headerContainer').height(),
			menuHeight = $('.menuContainer').height(),
			elementPosition,
			self = this,
			scrollTo;

		/*Force Open filters*/
		$filtersBlock.addClass('filtersOpened');

		elementPosition = this.$el.offset().top;
		scrollTo = elementPosition;

		headerHeight ? scrollTo -= headerHeight : '';
		menuHeight ? scrollTo -= menuHeight : '';

		scrollTo -= 50;

		setTimeout(function () {
			$filtersBlock.addClass('filtersOpened');
			self.$el.addClass("open")
		}, 1);

		if (elementPosition > currenPosition + windowHeight || elementPosition < currenPosition) {
			$("html,body").animate({scrollTop: scrollTo}, 200);
			return true;
		}

		return false;
	},
	$checkboxes: function () {
		this.$checkboxes = $('input[type="checkbox"]', this.$el);
	},
	setValue: function (model) {
		if (!model || !model.length) {
			this.$checkboxes.not('[value="all"]').prop('checked', false);
			this.$checkboxes.filter('[value="all"]').prop('checked', true);
		} else {
			this.$checkboxes.filter('[value="all"]').prop('checked', false);
			_.each(this.$checkboxes, function (checkbox) {
				var $checkbox = $(checkbox),
					hotelCategory = model.get($checkbox.val());

				if (hotelCategory && $checkbox.val() != "all") {
					$checkbox.prop('checked', true);
				} else {
					$checkbox.prop('checked', false);
				}
			});
		}
	},
	modelChanged: function (event, model, context) {
		if (!context || context.initiator !== 'view') {
			this.setValue(model);
		}
	},
	initEvents: function () {
		var self = this;
		this.model.on('change:model', $.proxy(this.modelChanged, this));
	},
	initDomEvents: function () {
		var self = this;
		_.each(this.$checkboxes, function (checkbox) {
			var $checkbox = $(checkbox);
			$checkbox.change($.proxy(self.checkboxChanged, self));
		});
	},
	checkboxChanged: function (event) {
		var departureCityType,
			defaultHotelCategories,
			hotelStars,
			$this = $(event.target),
			hotelCategories = [];

		tourCriteriaService.addTourCriteriaChangedField('hotelCategories');

		if ($this.is('[value="all"]') && !this.$checkboxes.filter(':checked').length) {
			departureCityType = this.departureCityData && this.departureCityData.get('model') ? this.departureCityData.get('model').get('type') : null;
			defaultHotelCategories = departureCityType ? this.countryData.get('model').at(0).get(departureCityType + 'TourCriteria').hotelCategories : (this.countryData.get('model') ? this.countryData.get('model').at(0).get('tourCriteria').hotelCategories : []);
			console.log('defaultHotelCategories', defaultHotelCategories);
			if (!defaultHotelCategories.length) {
				this.$checkboxes.not('[value="all"]').prop('checked', false);
				this.$checkboxes.filter('[value="all"]').prop('checked', true);
			} else {
				_.each(this.$checkboxes.not('[value="all"]'), function (checkbox) {
					var $checkbox = $(checkbox),
						model;

					if (_.contains(defaultHotelCategories, parseInt($checkbox.val(), 10))) {
						$checkbox.prop('checked', true);
						model = HotelCategoriesRepository.repository.get($checkbox.val());
						if (model) {
							hotelCategories.push(model);
						}
					}
				});
			}
		} else if ($this.is('[value="all"]') || !this.$checkboxes.not('[value="all"]').filter(':checked').length) {
			this.$checkboxes.not('[value="all"]').prop('checked', false);
			this.$checkboxes.filter('[value="all"]').prop('checked', true);
		} else {
			this.$checkboxes.filter('[value="all"]').prop('checked', false);
			_.each(this.$checkboxes.not('[value="all"]'), function (checkbox) {
				var $checkbox = $(checkbox),
					model;

				if ($checkbox.is(':checked')) {
					model = HotelCategoriesRepository.repository.get($checkbox.val());
					if (model) {
						hotelCategories.push(model);
					}
				}
			});
		}

		DataLayerAnalytics.toggleFilter($this.prop("checked"), $this.data("layer-name"));

		hotelStars = new HotelCategoriesRepository(hotelCategories);
		hotelStars.manuallyChanged = true;
		this.model.set('model', hotelStars, {initiator: 'view'});
		// this.notifyGA();
		console.log('Changed hotel categories: ' + hotelStars.pluck('name').join(', '));
	},
	initialize: function (options) {
		this.countryData = options.countryData;
		this.departureCityData = options.departureCityData;
		var self = this,
			model = this.model.get('model');

		this.$checkboxes();
		this.initEvents();
		this.initDomEvents();
		this.setValue(model);
	}
});

export default HotelCategoryView;